<template>
  <div class="config-page">
    <el-form ref="form" :model="formData" label-width="180px">
      <!-- 基础信息 -->
      <el-card class="box-card" header="基础信息">
        <div slot="header" class="clearfix">
          <span>基础信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="机构ID" prop="groupId">
              <el-input v-model="formData.groupId" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构名称" prop="groupName">
              <el-input v-model="formData.groupName"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="区县" prop="region">
              <el-input v-model="formData.region"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="街道" prop="street">
              <el-input v-model="formData.street"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="社区" prop="community">
              <el-input v-model="formData.community"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构地址" prop="groupAddress">
              <el-input v-model="formData.groupAddress"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="GPS地址" prop="gpsAddress">
              <el-input v-model="formData.gpsAddress"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构类型" prop="groupType">
              <el-select v-model="formData.groupType" placeholder="请选择">
                <el-option v-for="item in groupTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构目录" prop="groupCatalog">
              <el-select v-model="formData.groupCatalog" placeholder="请选择">
                <el-option v-for="item in groupCatalogOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="社会信用代码" prop="socialCode">
              <el-input v-model="formData.socialCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="营业执照" prop="picture">
              <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false" :on-remove="handleRemove" :http-request="uploadSectionFile"
              :before-upload="uploadSuccess">
              <img v-if="formData.picture" :src="formData.picture" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 负责人信息 -->
      <el-card class="box-card" header="负责人信息">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="负责人姓名" prop="directorName">
              <el-input v-model="formData.directorName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="directorPhone">
              <el-input v-model="formData.directorPhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="directorIdCard">
              <el-input v-model="formData.directorIdCard"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关联账号" prop="linkAccount">
              <el-input v-model="formData.linkAccount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法定代表人" prop="legalName">
              <el-input v-model="formData.legalName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成立时间" prop="constructionTime">
              <el-date-picker v-model="formData.constructionTime" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 机构评级与面积 -->
      <el-card class="box-card" header="机构评级与面积">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="星级评定" prop="starRating">
              <el-input v-model="formData.starRating"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="占地面积" prop="squareArea">
              <el-input v-model="formData.squareArea"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="建筑面积" prop="buildArea">
              <el-input v-model="formData.buildArea"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业状态" prop="openStatus">
              <el-select v-model="formData.openStatus" placeholder="请选择">
                <el-option v-for="item in openStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>


      <!-- 银行信息 -->
      <el-card class="box-card" header="银行信息">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开户银行" prop="bankName">
              <el-input v-model="formData.bankName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行账号" prop="bankNo">
              <el-input v-model="formData.bankNo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 床位与人员信息 -->
      <el-card class="box-card" header="床位与人员信息">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="床位总数" prop="bedNum">
              <el-input v-model="formData.bedNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="在院人数" prop="inNum">
              <el-input v-model="formData.inNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="护理床位数" prop="nursingBedNum">
              <el-input v-model="formData.nursingBedNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="员工总数" prop="employeesNum">
              <el-input v-model="formData.employeesNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编制人数" prop="establishmentNum">
              <el-input v-model="formData.establishmentNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="特困人数" prop="destituteNum">
              <el-input v-model="formData.destituteNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="儿童人数" prop="childrenNum">
              <el-input v-model="formData.childrenNum"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 财务信息 -->
      <el-card class="box-card" header="财务信息">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="固定资产" prop="fixedAssets">
              <el-input v-model="formData.fixedAssets"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="建设资金" prop="constructionFunds">
              <el-input v-model="formData.constructionFunds"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收入资金" prop="incomeFunds">
              <el-input v-model="formData.incomeFunds"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支出资金" prop="expendFunds">
              <el-input v-model="formData.expendFunds"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账面余额" prop="bookBalance">
              <el-input v-model="formData.bookBalance"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 备注信息 -->
      <el-card class="box-card" header="备注信息">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" :rows="4" v-model="formData.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 统计信息 -->
      <el-card class="box-card" header="统计信息">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="当月入住人数" prop="monthInNum">
              <el-input v-model="formData.monthInNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="今日告警数" prop="todayAlertNum">
              <el-input v-model="formData.todayAlertNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务完成率" prop="serviceCompletionRate">
              <el-input v-model="formData.serviceCompletionRate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备在线率" prop="deviceOnlineRate">
              <el-input v-model="formData.deviceOnlineRate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务满意度" prop="serviceSatisfactionRate">
              <el-input v-model="formData.serviceSatisfactionRate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年龄结构" prop="ageStructure">
              <el-input v-model="formData.ageStructure"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="日服务量" prop="serviceDayNum">
              <el-input v-model="formData.serviceDayNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="月服务量" prop="serviceMonthNum">
              <el-input v-model="formData.serviceMonthNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总服务量" prop="serviceTotalNum">
              <el-input v-model="formData.serviceTotalNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="每月入住人数列表" prop="inNumList">
              <el-input v-model="formData.inNumList"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="每月出院人数列表" prop="outNumList">
              <el-input v-model="formData.outNumList"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="每月收入列表" prop="incomeList">
              <el-input v-model="formData.incomeList"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-form>

    <!-- 底部操作按钮 -->
    <div class="footer-buttons">
      <el-button type="primary" @click="saveData">保存</el-button>
      <el-button @click="resetForm">重置</el-button>
    </div>


  </div>
</template>

<script>
export default {
  name: "groupDbData",
  data() {
    return {
        isFirst:true,
      // 表单数据
      formData: {
        groupId: sessionStorage.getItem("groupId"),
        
      },
      // 机构类型选项
      groupTypeOptions: [
        { value: 0, label: '事业单位' },
        { value: 1, label: '企业' },
        { value: 2, label: '民办非企业' },
        { value: 4, label: '其他' }
      ],
      // 机构目录选项
      groupCatalogOptions: [
        { value: 1, label: '公办' },
        { value: 2, label: '民办' },
        { value: 3, label: '公建民营' }
      ],
      // 开放状态选项
      openStatusOptions: [
        { value: '营业中', label: '营业中' },
        { value: '暂停营业', label: '暂停营业' },
        { value: '已关闭', label: '已关闭' }
      ],
      // 图片上传相关
      fileList: [{
        name: 'photo.jpg',
        url: 'https://picsum.photos/400/300'
      }],
      // 图片预览相关
      dialogVisible: false,
      dialogImageUrl: ''
    }
  },
  methods: {
    // 保存数据
    saveData() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 模拟保存API调用
          let url = 'uac/group/addDb';
          if(!this.isFirst){
             url = 'uac/group/updateDb';
          }
          this.$postJson(url,this.formData).then(res=>{
            console.log(res);
            this.$message({
                message: '数据保存成功',
                type: 'success'
            });
          })
          
        } else {
          console.log('验证失败');
          return false;
        }
      });
    },
    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
    },
    uploadSectionFile(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("dmc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.formData.picture = res.result; //添加图片的id
            console.log(this.formData)
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },
    //活动轮播图限制
    uploadSuccess(file) {
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 4;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PNG 格式!");
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 4MB!");
        }
      }
      return isJPG && isLt2M;
    },
    //删除图片
    handleRemove(file, fileList) {
      this.formData.picture = null;
    },
    getDbData(){
        this.$postJson("uac/group/getDb/"+sessionStorage.getItem("groupId")).then(res => {
              if(res && res.result && res.result.groupId){
                this.isFirst = false;
                this.formData = res.result;
              }
        });
    },
  },
  created() {
    // 模拟从API获取数据
    // this.fetchData();
  },
  mounted() {
    this.getDbData();
  }
};
</script>
<style lang="scss" scoped>
.config-page {
  padding: 20px;
  background-color: #f5f7fa;
}

.box-card {
  margin-bottom: 20px;
}

.footer-buttons {
  background-color: white;
  padding: 10px 20px;
  align-items: center;
  margin: 0 auto;
  text-align: center;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.footer-buttons button {
  margin-left: 10px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .el-upload{
  width: 88px;
  height: 88px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  border: 1px dashed #d9d9d9;
  line-height: 88px;
  text-align: center;
}
.avatar {
  width: 88px;
  height: 88px;
  display: block;
}
</style>